import { useState, useEffect } from 'react';
import { Button} from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext';
import { usePost } from '../../../apis/ApiRequests';
import Header from '../../../components/uiParts/hygiene/Header';
import TitleBar from '../../../components/uiParts/TitleBar';
import Frame from '../../../components/uiParts/Frame';
import { CustomDataGrid } from '../../../components/dataGrid/CustomDataGrid';
import { jaJP } from '@mui/x-data-grid';
import { dateToString, stringToDate } from '../../../utils/Library';

const HygineAlertList = () => {
    
    const { authInfo, setAuthInfo } = useAuth();

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode = authInfo.facilityCode;
    const facilityName = authInfo.facilityName;
    const userId = authInfo.userId;
    const userName = authInfo.userName;
    const authority = authInfo.authority;
    const traderCode = authInfo.traderCode;
    const trader = authInfo.trader;
    const today = authInfo.targetDate;
    
	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ dataGridHeight, setDataGridHeight ] = useState(window.innerHeight - 170);
    const [ condition , setCondition ] = useState('');
    const [ searchCount, setSearchCount ] = useState(0);
    const [ dataList, setDataList ] = useState([]);
    const [ targetList, setTargetList ] = useState('');
    const [ targetDate, setTargetDate ] = useState(today);
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchData / table_Alert
	//-----------------------------------------------
    const { response : searchData_Res, loading : searchData_Loading, post:searchData_Post } = usePost();
    const searchData = async () => {
            const numericDate = dateToString(targetDate);
        const postData = {
            'className'    : 'mch.models.table.HygieneAlert',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate
        }
        await searchData_Post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1);
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 170);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - searchData / masta_BidPerson
	//-----------------------------------------------
    useEffect(() => {
        setDataList([]);
        if (searchData_Res) {
            setDataList(searchData_Res.Data);
        }
    }, [searchData_Res]);

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
        setTargetDate(value);
        setSearchCount(searchCount+1);
    };
    //===============================================
    // dataGird
    //===============================================
    //-----------------------------------------------
    // dataGird - テーブルの見出し
    //-----------------------------------------------
    const columns = [
        { field: 'alertTime', headerName: '発生時刻', width: 80, columnSeparatorWidth: 1, },
        { field: 'lineNo', headerName: '水槽No', width: 80, columnSeparatorWidth: 1, },
        { field: 'sensorTypeText', headerName: '種別', width: 80, columnSeparatorWidth: 1, },
        { field: 'errorText', headerName: 'アラート内容', width: 900, columnSeparatorWidth: 1, },
    ];
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataGrid = (event) => {
        setTargetList(event.row);
    };
    //===============================================
    // Css
    //===============================================
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/hygieneHome" setEntryDate={handleChange_entryDate} />
            <div className='hygineAlertList bodyContens'>
                <TitleBar title="アラートリスト" color="#d66a35" />
                <div className='mainContents'>
                    <Frame classname="frame" title="アラート一覧" color="#d66a35">
                        <CustomDataGrid
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                            }
                            editMode                = "row"
                            rows                    = { dataList }
                            columns                 = { columns }
                            sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                            density                 = "compact"
                            localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                            showColumnRightBorder
                            showCellRightBorder
                            initialState            = {{pagination: { paginationModel: { pageSize: 100 } },}}
                            pageSizeOptions         = {[50, 100, 150, 200]}
                            loading                 = { searchData_Loading }
                            onCellClick             = {(event) => handleClick_dataGrid(event)}
                        />
                    </Frame>
				</div>
            </div>
        </>
    )
}
export default HygineAlertList;